import { DateTime } from 'luxon';
import { UUID } from 'types/shared/UUID';
import { IOrderTaskData } from 'types/tasks';
import { getDateFromTimeStamp, getTime, normalizeTimeStamp, toLocalTimeZone } from 'utilities/timeHelpers';

export interface IEditField {
  submitOnChange?: boolean;
  cancel?: () => void;
}

export interface IFieldName {
  fieldName: keyof Pick<IOrderTaskData, 'dueDate' | 'completedAt'>;
}

interface IEditTaskFormData {
  id: UUID;
  description?: string;
  dueDateDate?: string;
  dueDateTime?: string;
  teammate?: string;
  priorityScore?: number;
  role?: string | null;
}

export const combineDateAndTime = (date?: string | null, time?: string | null) => {
  let combinedDateAndTime = date ? DateTime.fromISO(date) : undefined;
  if (time && combinedDateAndTime) {
    const dt = DateTime.fromFormat(time, 'HH:mm');
    combinedDateAndTime = combinedDateAndTime?.set({ hour: dt.hour, minute: dt.minute });
  }
  return combinedDateAndTime && normalizeTimeStamp(combinedDateAndTime.toLocal().toISO());
};

export const taskToEditFormData = (task: IOrderTaskData): IEditTaskFormData => {
  const dueDateDate = task.dueDate ? getDateFromTimeStamp(task.dueDate) : undefined;
  const dueDateTime = task.dueDate ? getTime(toLocalTimeZone(task.dueDate)) : undefined;
  return {
    id: task.id!,
    description: task.description,
    dueDateDate,
    dueDateTime,
    teammate: task.teammate?.id,
    priorityScore: task.priorityScore,
    role: task.role ?? null,
  };
};
